/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
import { r as registerInstance, c as createEvent, h, g as getElement } from './index-ef0fa435.js';
import { i as isArray } from './isArray-ba17b1aa.js';
import { i as isObject } from './isObject-036bb226.js';
import { i as isNumber } from './isNumber-f0cb5287.js';
import { d as baseClone } from './_baseClone-5b9e04e8.js';
import { D as DoorState } from './sliding-door-interface-7c209a7c.js';
import './isObjectLike-0c552769.js';
import './global-3053f997.js';
import './_getAllKeys-4fdbf8d3.js';
import './_isIndex-11d39322.js';
import './isLength-dd14023c.js';
import './_getTag-35542633.js';
import './_baseAssignValue-0c712625.js';
import './_defineProperty-f2b25ce4.js';

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

const slidingDoorCss = "";

const SlidingDoorNode = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.output = createEvent(this, "output", 7);
    this.request = createEvent(this, "request", 7);
    this.icon = 'off';
    this.color = 'primary';
    this.colorModal = undefined;
    this.colorInputs = undefined;
    this.colorIconSmall = undefined;
    this.disableQuickActions = false;
    this.allowIndicationAutoColoring = false;
    this.hideTitles = undefined;
    this.supTitle = undefined;
    this.subTitle = undefined;
    this.log = true;
    this.mainTitle = undefined;
    this.nodeSize = 'default';
    this.loading = true;
    this.doorState = undefined;
    this.fullState = {
      doorState: undefined,
      doorStateString: DoorState.UNKNOWN,
      slidingTimerRunning: false,
      slidingTimerElapsed: 0,
      slidingTimerTimeout: 0,
      slidingTimerStartedAt: 0,
      stopEnabled: false
    };
    this.timerValue = undefined;
  }
  componentDidLoad() {
    const el = this.el.shadowRoot || this.el;
    this.node = el.querySelector('lar-node');
    this.output.emit({ command: 'get' });
  }
  /**
   * Larva error input
   */
  async error(data) {
    if (this.node) {
      this.node.error(data);
    }
    this.loading = false;
  }
  /**
   * Input Larva event message (see above)
   */
  async input(data) {
    if (isArray(data)) ;
    else if (isObject(data)) {
      const lastState = clone(this.fullState);
      this.fullState = data;
      if (this.fullState.slidingTimerRunning && isNumber(this.fullState.slidingTimerElapsed) && isNumber(this.fullState.slidingTimerTimeout)) {
        if (!this.timer || lastState.slidingTimerStartedAt !== this.fullState.slidingTimerStartedAt) {
          // restart the timer if slidingTimerStartedAt has changed
          this.startTimer();
        }
      }
      if (!this.fullState.slidingTimerRunning && this.timer) {
        this.resetTimer();
      }
    }
    this.loading = false;
  }
  resetTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
  startTimer() {
    this.timerValue = this.fullState.slidingTimerElapsed;
    const intervalTime = 1000;
    this.resetTimer();
    this.timer = setInterval(() => {
      try {
        if (!this.fullState.slidingTimerRunning || this.timerValue > this.fullState.slidingTimerTimeout) {
          this.resetTimer();
          // timer should have been stopped by now
          // make read request to get the state
          this.output.emit({ command: 'get' });
          this.loading = true;
        }
        this.timerValue += intervalTime;
      }
      catch (err) {
        console.error(err);
      }
    }, intervalTime);
  }
  sendCommand(cmd) {
    this.output.emit({ command: cmd });
    this.loading = true;
  }
  render() {
    let value = this.loading ? '' : 'slidingDoor.stateUnknown';
    let iconSmall = '';
    let colorIconSmall = this.colorIconSmall;
    switch (this.fullState.doorStateString) {
      case DoorState.CLOSED: {
        value = 'slidingDoor.stateClosed';
        iconSmall = 'lock';
        colorIconSmall = this.allowIndicationAutoColoring ? 'success' : this.colorIconSmall;
        break;
      }
      case DoorState.OPEN: {
        value = 'slidingDoor.stateOpen';
        iconSmall = 'unlock';
        colorIconSmall = this.allowIndicationAutoColoring ? 'danger' : this.colorIconSmall;
        break;
      }
      case DoorState.OPENING: {
        iconSmall = 'moving-cogs';
        value = 'slidingDoor.stateOpening';
        break;
      }
      case DoorState.CLOSING: {
        iconSmall = 'moving-cogs';
        value = 'slidingDoor.stateClosing';
        break;
      }
    }
    const componentProps = {
      doorState: this.fullState.doorStateString,
      stopEnabled: Boolean(this.fullState.stopEnabled),
      color: this.colorInputs || this.color,
      loading: this.loading,
      onSendcommand: (ev) => this.sendCommand(ev.detail),
    };
    return (h("lar-node", { value: value, hideTitles: this.hideTitles, icon: this.icon, iconSmall: iconSmall, color: this.color, supTitle: this.supTitle, mainTitle: this.mainTitle, subTitle: this.subTitle, colorModal: this.colorModal, colorInputs: this.colorInputs, colorIconSmall: colorIconSmall, loading: this.loading, log: this.log, nodeSize: this.nodeSize, component: "sliding-door-content", componentProps: componentProps }, this.disableQuickActions === false &&
      h("lar-button-push", { size: "small", slot: "titles", color: this.colorInputs || this.color, disabled: this.loading || this.fullState.slidingTimerRunning || !this.fullState.doorStateString || this.fullState.doorStateString === DoorState.UNKNOWN || this.fullState.doorStateString === DoorState.OPENING || this.fullState.doorStateString === DoorState.CLOSING, onClick: ev => this.fullState.doorStateString === DoorState.CLOSED ? this.sendCommand('open') : this.sendCommand('close') }), h("slot", null)));
  }
  get el() { return getElement(this); }
};
SlidingDoorNode.style = slidingDoorCss;

export { SlidingDoorNode as lar_sliding_door };

//# sourceMappingURL=lar-sliding-door.entry.js.map